import { css } from 'styled-components';

const storeSpecialPromotion = css`
  &.pickup-price-promotion {
    display: flex;
    align-items: center;
    padding: 8px;
    cursor: pointer;
    gap: 8px;
    border-radius: 6px;
    border: 1px solid #d8d8d8;

    .shipping-icon,
    .pickup-icon {
      margin-right: 24px;
      margin-left: 24px;
      height: 24px;
    }

    .pickup-text {
      color: #000;
      font-feature-settings: 'liga' off, 'clig' off;
      font-family: Nunito;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 140%; /* 19.6px */
    }

    .discounted-price {
      color: #000;
      font-feature-settings: 'liga' off, 'clig' off;
      font-family: Nunito;
      font-size: 16px;
      font-style: normal;
      font-weight: 800;
      line-height: 140%;
    }
  }
`;

export default storeSpecialPromotion;
